module.exports = __webpack_public_path__ + "static/media/James Buchanan - 1856.4f7a6fe7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/us/James Buchanan - 1856.jpg
// module id = 500
// module chunks = 0